import { Injectable } from '@angular/core';
import { Event } from '../model/event';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Output, EventEmitter } from '@angular/core';
import { environment } from '../../environments/environment.prod';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class EventService {

  eventresultlist: any;
  
  

  // eventdatalist: Array<Event> = ([

  //   { eventid: 1, topic: '2019 MakinG Connections Program - 1', eventdate: '04', eventmonth: 'March',
  //     eventtime: '4 PM', eventendtime: '8 PM', timezone: 'EST',
  //    speaker: 'SpeakerFirst SpeakerLast',
  //   location: '4000 Executive Pkwy, San Ramon, CA 94583, USA', eventype: 1,
  //   discription: 'Listen to a physician speak about generalized myasthenia gravis management' +
  //   ' and hear from a patient or caregiver share their story about living with gMG. Ask questions' +
  //   '  and gather information to potentially discuss with your doctor.'
  //   , lat: 10, lang: 11.5, state: 'AK' },

  //   { eventid: 2, topic: '2019 MakinG Connections Program - 2', eventdate: '15', eventmonth: 'April',
  //    eventtime: '1 PM', eventendtime: '5 PM', timezone: 'IST',
  //   speaker: 'SpeakerFirst SpeakerLast',
  //   location: '55 Beattie Pl, Greenville, SC 29601, USA', eventype: 2,
  //   discription: 'Listen to a physician speak about generalized myasthenia gravis management' +
  //   ' and hear from a patient or caregiver share their story about living with gMG. Ask questions' +
  //   '  and gather information to potentially discuss with your doctor.'
  //   , lat: 10, lang: 11.5, state: 'AL'},

  //   { eventid: 3, topic: '2019 MakinG Connections Program - 3', eventdate: '09 ', eventmonth: 'May',
  //    eventtime: '2 PM', eventendtime: '6 PM', timezone: 'Pacific' ,
  //   speaker: 'SpeakerFirst SpeakerLast',
  //   location: '1001 Durham Ave, South Plainfield, NJ 07080, USA', eventype: 1,
  //   discription: 'Listen to a physician speak about generalized myasthenia gravis management' +
  //   ' and hear from a patient or caregiver share their story about living with gMG. Ask questions' +
  //   '  and gather information to potentially discuss with your doctor.' ,
  //   lat: 10, lang: 11.5, state: 'AR'},

  //   { eventid: 4, topic: '2019 MakinG Connections Program - 4', eventdate: '08', eventmonth: 'Dec',
  //     eventtime: '9 PM', eventendtime: '11 PM', timezone: 'PST',
  //    speaker: 'SpeakerFirst SpeakerLast',
  //   location: '20700 Civic Center Dr, Southfield, MI 48076, USA', eventype: 2,
  //   discription: 'Listen to a physician speak about generalized myasthenia gravis management' +
  //   ' and hear from a patient or caregiver share their story about living with gMG. Ask questions' +
  //   '  and gather information to potentially discuss with your doctor.'
  //   , lat: 10, lang: 11.5, state: 'AK' },

  // ]);

  @Output() outputbystate: EventEmitter<Array<Event>> = new EventEmitter();

  constructor( private http: HttpClient) { }

  apiUrl = environment.apiURL;
  brandId = environment.brandId;

  getEvents(): Observable<any>{
    const filterObject = {
      brandId : this.brandId,
    };
    let fullURL = this.apiUrl + 'events?filter=';
    return this.http.get(fullURL + encodeURIComponent(JSON.stringify(filterObject))); 
}

getEventsByFilter(state): Observable<any>{
  let fullURL = this.apiUrl + 'events?filter=';

  if(state!=''){
    const filterObject = {
      brandId : this.brandId,
      state:state
    };
    return this.http.get(fullURL + encodeURIComponent(JSON.stringify(filterObject))); 

  }
  else{
    const filterObject = {
      brandId : this.brandId,
    };
    return this.http.get(fullURL + encodeURIComponent(JSON.stringify(filterObject))); 
  }
  
}

emitEvent(res){
  console.log("emit event");
  this.outputbystate.emit(res);
}
  getbyfilter(eventdatalist : any,statename: any, isWebinar: any, islive: any) {

    this.eventresultlist = eventdatalist;
     
    if (isWebinar && islive && statename.length > 0) {
      this.eventresultlist = eventdatalist.filter( (x: any) => x.state === statename || x.meeting_type_id === 2);
    } else if ( !isWebinar && !islive && statename.length > 0) {
      this.eventresultlist = eventdatalist.filter( (x: any ) => x.meeting_type_id === 0);
    } else if (isWebinar && statename.length > 0) {
      this.eventresultlist = this.eventresultlist.filter( (x: any ) => x.meeting_type_id === 2);
    } else if (islive && statename.length  > 0) {
      this.eventresultlist = this.eventresultlist.filter( (x: any ) => x.state === statename).filter( (x: any ) => x.meeting_type_id === 1);
    }
    this.outputbystate.emit(this.eventresultlist);
  }
}
